export const COLLABORATION_CHANGED = 'crm:collaboration-changed';
export const notifyCollaborationChanged = () =>
  window.dispatchEvent(new Event(COLLABORATION_CHANGED));
